import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import Logo from "../../../Assets/Logo.svg";
import { PortalLogin } from "../PortalLogin";
import SettingsIcon from "@mui/icons-material/Settings";
import { logout } from "../../../services/auth/auth";
import { Dispatch } from "@reduxjs/toolkit";
import {
  Badge,
  ButtonGroup,
  Drawer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import {
  removeCart,
  removeFromCart,
  setOpenCheckout,
  updateCartItemQuantity,
} from "../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";
import DashboardIcon from "@mui/icons-material/Dashboard";
export const Header: React.FunctionComponent = () => {
  const { customerData, storeAccessToken } = useSelector(
    (state: AppState) => state.authReducer
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const dispatch = useDispatch<Dispatch<any>>();
  const cart = useSelector(
    (state: AppState) => state.shoppingPortalReducer.cart
  );
  const logoUrl = useSelector(
    (state: AppState) => state.shoppingPortalReducer.logoUrl
  );
  const [cartOpen, setCartOpen] = React.useState(false);

  const [profilePopup, setProfilePopup] = React.useState(false);

  const getTotalBill = () => {
    return cart.reduce((sum, obj) => sum + obj.price * obj.quantity, 0);
  };

  const handleProfileClick = (event: React.MouseEvent<HTMLElement>) => {
    setProfilePopup(!profilePopup);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setProfilePopup(false);
    setAnchorEl(null);
  };
  const handleRemoveCart = () => {
    dispatch(removeCart());
  };
  const Logout = () => {
    setAnchorEl(null);
    dispatch(logout());
  };
  const handleNavigateToCustomerPortal = () => {
    window.open("/", "_blank");
  };
  return (
    <>
      <AppBar sx={{ backgroundColor: "#ffffff" }} position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
            >
              <img style={{ maxHeight: "8vh" }} src={logoUrl ?? Logo}></img>
            </Typography>
            <Typography
              noWrap
              component="div"
              sx={{ flexGrow: 1, mt: 2, display: { xs: "flex", md: "none" } }}
            >
              <img style={{ maxWidth: 67 }} src={logoUrl ?? Logo}></img>
            </Typography>

            <Box
              sx={{
                flexGrow: 0,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {storeAccessToken ? (
                <Box sx={{ flexGrow: 0, pr: 2 }}>
                  <Typography style={{ color: "#38376e" }} fontWeight={"bold"}>
                    Hi {customerData?.firstName}!
                  </Typography>
                </Box>
              ) : (
                ""
              )}
              <Box sx={{ flexGrow: 0 }}>
                <IconButton sx={{ p: 0, mr: 2 }} onClick={handleProfileClick}>
                  <PersonOutlineIcon sx={{ color: "black" }} />
                </IconButton>
              </Box>
              <IconButton
                onClick={() => {
                  setCartOpen(true);
                }}
                sx={{ p: 0 }}
              >
                {cart && cart.length > 0 ? (
                  <Badge badgeContent={cart.length} color="primary">
                    <ShoppingBagOutlinedIcon sx={{ color: "black" }} />
                  </Badge>
                ) : (
                  <ShoppingBagOutlinedIcon sx={{ color: "black" }} />
                )}
              </IconButton>
            </Box>
            <Drawer
              anchor="right"
              open={cartOpen}
              onClose={() => setCartOpen(false)}
            >
              <Box width="auto" sx={{ margin: 2 }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <h2>Your Cart</h2>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setCartOpen(false);
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    id="basic-button"
                    sx={{ fontSize: "0.7125rem" }}
                    size="small"
                    variant="contained"
                    disabled={cart && cart.length > 0 ? false : true}
                    color="warning"
                    onClick={handleRemoveCart}
                    endIcon={<CancelIcon fontSize="small" />}
                  >
                    Clear
                  </Button>
                </Box>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Part Number</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell align="right">Price($)</TableCell>
                        <TableCell align="center">Qty.</TableCell>
                        <TableCell align="right">Total($)</TableCell>
                        <TableCell align="center">Remove</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cart && cart.length > 0 ? (
                        cart.map((row, index: number) => (
                          <TableRow key={index}>
                            <TableCell>{row.partNumber}</TableCell>
                            <TableCell>{row.description}</TableCell>
                            <TableCell align="right">{row.price}</TableCell>
                            <TableCell align="center">
                              {" "}
                              <ButtonGroup
                                size="small"
                                aria-label="small outlined button group"
                              >
                                <Button
                                  onClick={() => {
                                    dispatch(
                                      updateCartItemQuantity({
                                        inventorypartId: row.inventoryPartId,
                                        quantity: row.quantity + 1,
                                      })
                                    );
                                  }}
                                >
                                  +
                                </Button>
                                <Button>{row.quantity}</Button>
                                <Button
                                  onClick={() => {
                                    if (row.quantity > 1) {
                                      dispatch(
                                        updateCartItemQuantity({
                                          inventorypartId: row.inventoryPartId,
                                          quantity: row.quantity - 1,
                                        })
                                      );
                                    }
                                  }}
                                >
                                  -
                                </Button>
                              </ButtonGroup>
                            </TableCell>
                            <TableCell align="right">
                              {(row.price * row.quantity).toFixed(2)}
                            </TableCell>
                            <TableCell align="center">
                              {" "}
                              <IconButton
                                onClick={() => {
                                  dispatch(
                                    removeFromCart({
                                      inventoryPartId: row.inventoryPartId,
                                    })
                                  );
                                }}
                                sx={{ p: 0 }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={6}
                            sx={{ fontWeight: "bold" }}
                            align="center"
                          >
                            No Items to show
                          </TableCell>
                        </TableRow>
                      )}
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          sx={{ fontWeight: "bold" }}
                          align="right"
                        >
                          Grand Total($)
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                          {getTotalBill().toFixed(2)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box mt={4} display="flex" justifyContent="flex-end">
                  <Button
                    disabled={!(cart && cart.length > 0)}
                    variant="contained"
                    onClick={() => {
                      setCartOpen(false);
                      dispatch(setOpenCheckout({ isOpen: true }));
                    }}
                  >
                    Checkout
                  </Button>
                </Box>
              </Box>
            </Drawer>
          </Toolbar>
        </Container>
      </AppBar>
      {storeAccessToken ? (
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem
            onClick={handleNavigateToCustomerPortal}
            sx={{ fontSize: "14px" }}
          >
            <DashboardIcon sx={{ marginRight: 1 }} fontSize="small" /> Dashboard
          </MenuItem>
          <MenuItem onClick={() => {}} sx={{ fontSize: "14px" }}>
            <SettingsIcon fontSize="small" sx={{ marginRight: 1 }} /> Setting
          </MenuItem>
          <MenuItem onClick={Logout} sx={{ fontSize: "14px" }}>
            <LogoutIcon sx={{ marginRight: 1 }} fontSize="small" /> Log Out
          </MenuItem>
        </Menu>
      ) : (
        <PortalLogin isOpen={profilePopup} onClose={handleClose}></PortalLogin>
      )}
    </>
  );
};
